function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M21.3676 6.42581H2.6321C1.85791 6.42581 1.16113 7.04517 1.16113 7.89678V13.1613C1.16113 13.9355 1.78049 14.6323 2.6321 14.6323H21.445C21.8321 14.6323 22.2192 14.4774 22.4515 14.1677C22.7611 13.8581 22.916 13.5484 22.916 13.1613V7.81936C22.8386 7.04517 22.2192 6.42581 21.3676 6.42581ZM1.85791 7.81936C1.85791 7.35484 2.16758 7.04517 2.6321 7.04517H21.3676C21.8321 7.04517 22.1418 7.35484 22.1418 7.81936V8.67097H1.85791V7.81936ZM21.9869 13.7032C21.8321 13.8581 21.6773 13.9355 21.445 13.9355H2.6321C2.16758 13.9355 1.85791 13.6258 1.85791 13.1613V9.05807H22.1418V13.1613C22.1418 13.3161 22.1418 13.5484 21.9869 13.7032Z",
  fill: "#656D77"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.9938 12.7742H10.1421C10.0647 12.7742 9.9873 12.8516 9.9873 12.929C9.9873 13.0065 10.0647 13.0839 10.1421 13.0839H10.9938C11.0712 13.0839 11.1486 13.0065 11.1486 12.929C11.226 12.8516 11.1486 12.7742 10.9938 12.7742Z",
  fill: "#656D77"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.7808 12.7742H13.2388C13.1614 12.7742 13.084 12.8516 13.084 12.929C13.084 13.0065 13.1614 13.0839 13.2388 13.0839H13.7808C13.8582 13.0839 13.9356 13.0065 13.9356 12.929C13.9356 12.8516 13.9356 12.7742 13.7808 12.7742Z",
  fill: "#656D77"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M2.94166 15.1742C2.78682 15.0968 2.55457 15.1742 2.47715 15.329L1.78037 17.0323C1.70295 17.1871 1.78037 17.4194 1.93521 17.4968C1.93521 17.4968 2.01263 17.4968 2.09005 17.4968C2.24489 17.4968 2.32231 17.4194 2.39973 17.2645L3.0965 15.5613C3.17392 15.4839 3.0965 15.2516 2.94166 15.1742Z",
  fill: "#656D77"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M4.56771 15.1742C4.41287 15.0968 4.18061 15.1742 4.10319 15.4064L3.56126 17.1097C3.48384 17.2645 3.56126 17.4968 3.79352 17.5742H3.87094C4.02577 17.5742 4.18061 17.4968 4.18061 17.3419L4.72255 15.6387C4.87739 15.4839 4.79997 15.2516 4.56771 15.1742Z",
  fill: "#656D77"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.19341 15.1742C6.03857 15.1742 5.80631 15.2516 5.80631 15.4065L5.3418 17.1097C5.3418 17.2645 5.41922 17.4968 5.57405 17.4968H5.65147C5.80631 17.4968 5.96115 17.4194 5.96115 17.1871L6.42567 15.4839C6.50309 15.4065 6.42567 15.2516 6.19341 15.1742Z",
  fill: "#656D77"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M7.89697 15.1742C7.74213 15.1742 7.50987 15.2516 7.50987 15.4839L7.2002 17.1871C7.2002 17.342 7.27761 17.5742 7.50987 17.5742H7.58729C7.74213 17.5742 7.89697 17.4194 7.89697 17.2645L8.20665 15.5613C8.20665 15.4065 8.05181 15.2516 7.89697 15.1742Z",
  fill: "#656D77"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M9.5224 15.1742C9.36757 15.1742 9.13531 15.329 9.13531 15.4839L8.98047 17.1871C8.98047 17.342 9.13531 17.5742 9.29015 17.5742C9.44498 17.5742 9.59982 17.4194 9.59982 17.2645L9.75466 15.5613C9.83208 15.329 9.75466 15.1742 9.5224 15.1742Z",
  fill: "#656D77"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M11.2253 15.1742C10.993 15.1742 10.8382 15.329 10.8382 15.4839L10.7607 17.1871C10.7607 17.342 10.9156 17.5742 11.0704 17.5742C11.2253 17.5742 11.3801 17.4194 11.3801 17.2645L11.4575 15.5613C11.5349 15.329 11.3801 15.1742 11.2253 15.1742Z",
  fill: "#656D77"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.8517 15.1742C12.6968 15.1742 12.542 15.329 12.542 15.5613L12.6194 17.2645C12.6194 17.4194 12.7743 17.5742 12.9291 17.5742C13.0839 17.5742 13.2388 17.4194 13.2388 17.1871L13.1613 15.4839C13.1613 15.329 13.0065 15.1742 12.8517 15.1742Z",
  fill: "#656D77"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.4776 15.1742C14.3228 15.1742 14.168 15.329 14.168 15.5613L14.3228 17.2645C14.3228 17.4194 14.4776 17.5742 14.6325 17.5742C14.7873 17.5742 14.9422 17.4194 14.9422 17.1871L14.8647 15.4839C14.8647 15.329 14.7099 15.1742 14.4776 15.1742Z",
  fill: "#656D77"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M16.4897 15.4839C16.4897 15.329 16.2575 15.1742 16.1026 15.1742C15.9478 15.1742 15.793 15.4065 15.793 15.5613L16.1026 17.2645C16.1026 17.4194 16.2575 17.5742 16.4123 17.5742C16.4123 17.5742 16.4123 17.5742 16.4897 17.5742C16.6446 17.5742 16.7994 17.342 16.7994 17.1871L16.4897 15.4839Z",
  fill: "#656D77"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M18.1937 15.4839C18.1937 15.329 17.9614 15.1742 17.8066 15.2516C17.6517 15.2516 17.4969 15.4839 17.5743 15.6387L18.0388 17.3419C18.0388 17.4968 18.1937 17.5742 18.3485 17.5742H18.4259C18.5808 17.5742 18.7356 17.3419 18.6582 17.1871L18.1937 15.4839Z",
  fill: "#656D77"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.8971 15.4065C19.8196 15.2516 19.6648 15.0968 19.4325 15.1742C19.2777 15.2516 19.1229 15.4065 19.2003 15.6387L19.7422 17.3419C19.8196 17.4968 19.8971 17.5742 20.0519 17.5742H20.1293C20.2842 17.4968 20.439 17.3419 20.3616 17.1097L19.8971 15.4065Z",
  fill: "#656D77"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M21.5228 15.4065C21.4454 15.2516 21.2131 15.1742 21.0583 15.2516C20.9034 15.2516 20.826 15.4839 20.9034 15.6387L21.6002 17.3419C21.6776 17.4968 21.755 17.5742 21.9099 17.5742C21.9873 17.5742 21.9873 17.5742 22.0647 17.5742C22.2195 17.4968 22.297 17.2645 22.2195 17.1097L21.5228 15.4065Z",
  fill: "#656D77"
});

var SvgConditioner = function SvgConditioner(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgConditioner, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/conditioner.918425cc.svg";
export { ForwardRef as ReactComponent };